import React from 'react';
import PropTypes, { func, bool } from 'prop-types';
import { IconFont } from 'ui-component-library';

import { NavButton, DropdownMenu } from './dropdown-nav-button.style';
import theme from '../../../../../theme';

/**
 * Dropdown Navigation button
 * @param {object} props - Object containing the props for this component
 * @param {string} props.icon - icon for nav menu item
 * @param {array} props.children - array of jsx components
 * @param {bool} props.isOpen - if the menu is open or not
 * @param {func} props.openMenu - function to open/close the menu
 * @return {element}
 */
const DropdownNavButton = ({
  icon,
  children,
  isOpen,
  openMenu,
}) => (
  <>
    <NavButton
      isActive={isOpen}
      onClick={() => openMenu(!isOpen)}
      onBlur={() => openMenu(false)}
    >
      <IconFont icon={icon} color={theme.palette.white} size="30px" />
    </NavButton>
    {isOpen
      && (
      <DropdownMenu onMouseDown={(event) => event.preventDefault()}>
        {children}
      </DropdownMenu>
      )}
  </>
);

DropdownNavButton.propTypes = {
  icon: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isOpen: bool,
  openMenu: func,
};

DropdownNavButton.defaultProps = {
  children: null,
  isOpen: false,
  openMenu: () => {},
};

export default DropdownNavButton;
